import { render, staticRenderFns } from "./PostCategoryAdd.vue?vue&type=template&id=3c74670b&"
import script from "./PostCategoryAdd.vue?vue&type=script&lang=js&"
export * from "./PostCategoryAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports